<script>
	document.getElementsByTagName('body')[0].style.display = 'none'
	
	import {sQuery as sq} from './sq.js';
	//export let name;
	import {name, loadProc} from './docs.js'
	import Sqi from './Sq_editorI.svelte'

	if (sq().isPageLoaded())
	{
		console.log('spa loaded')
		setTimeout(() => {
			loadProc()
			appendReload()
		}, 1);
	}
	sq(()=>{
		loadProc()
		appendReload()
	})
	function appendReload(){
		sq('.cDesc').each(function(){
			sq(this).append('<div class="cReload">reload</div>')
		})
		sq('.cReload').show()
		sq('.cReload').on('click', function(){
			const el = sq(this).parent().parent().find('iframe')
			el.attr('src', el.attr('src') )
		})
	}
</script>

<main>
	<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/prism/1.25.0/themes/prism-tomorrow.min.css">
	<script src="https://cdnjs.cloudflare.com/ajax/libs/prism/1.25.0/prism.min.js"></script>
	<link rel="stylesheet" href="./Docs.css">
	<section id="idHead">
		<span id="idDocNav"></span>
		<div class="cBtnTrans"><a href="https://squery-vercel-app.translate.goog/?&_x_tr_sl=auto&_x_tr_tl=ja&_x_tr_hl=en&_x_tr_pto=wapp#/examples">日本語に翻訳</a></div>
	</section>
	
	<section id="idLeft">
		<section id="idLeftTop">
			<div id="idLeftLogo" class="notranslate"><a href="./" style="color:#fff">sQuery HOME</a></div>
		
			<div id="idLeftSearchCont">
				<hr>
				<div style="position:relative">
					<input id="idDS" type="text" placeholder="search docs" autocorrect="off" autocapitalize="off" spellcheck="false">
					<div id="idDSC">&times;</div>
				</div>
			</div>
		</section>

		<section class="cScrollable">
			<div name="" class="cSub">Examples</div>
			<div name="fetch" class="cF notranslate">fetch (alternative $.ajax)</div>
			<div name="axios" class="cF notranslate">axios (alternative $.ajax)</div>
	
			<br><br><br><br><br><br><br><br>
		</section>
	</section>
	

	<div class="menu__toggler"><span></span></div>

	<section id="idDoc">
		<h1><span onclick="location.href='./';" style="cursor:pointer">sQuery Examples<div>{name}</div></span></h1>

		<doc name="fetch">
			<h2 class="notranslate">fetch</h2>
			<div class="cPreDesc">
				In this example, I'm going to show you $.ajax like example using the ES6 native fetch function. 
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					fetch
				</div>
				<Sqi cname="fetch" mh="410"></Sqi>
			</div>
		</doc>


		<doc name="axios">
			<h2 class="notranslate">axios</h2>
			<div class="cPreDesc">
				In this example, I'm going to show you $.ajax like example using axios. 
			</div>
			<div>
				<div class="cDesc">
					<div class="cBack"></div>
					axios
				</div>
				<Sqi cname="axios" mh="410"></Sqi>
			</div>
		</doc>


	</section>
</main>

<style>

</style>